import { render, staticRenderFns } from "./SundryCreditorAttachments.vue?vue&type=template&id=42d4357c"
import script from "./SundryCreditorAttachments.vue?vue&type=script&lang=js"
export * from "./SundryCreditorAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports